import {saved as savedMoney, totalSpent} from 'core/LifeCycle';
import {percent} from 'shared/utils/number/percent';

export function createPayload({budget, history}: AppState): UserSavedMoneyEventPayload {
  const saved = savedMoney(budget, history);
  const spent = totalSpent(budget, history);
  const total = saved + spent;
  return {absolute: saved, percent: percent(saved, total)};
}
